import styled from 'styled-components';

export * from './base.styled';

export const DetailsBox = styled.div`
  background-color: ${Styles.color.cardBackground};
  border-radius: ${Styles.borderRadius};
  box-shadow: ${Styles.boxShadow};
  display: flex;
  flex-direction: column;
  padding: 1.25rem 1.5rem;
  font-style: normal;
  font-size: 0.9375rem;
  font-family: ${Styles.fontFamily.body};
  outline: ${p => p.theme.cardOutline};
`;

export const Text = styled.div`
  margin-block-end: 0.5rem;
`;

export const Address = styled.span`
  font-weight: ${Styles.fontWeight.heavy};
`;

export const LinkDisplay = styled.div``;
